function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-ppsr-disabled_svg__cls-2{fill:none;stroke:#c9c9c9;stroke-linecap:round;stroke-linejoin:round;stroke-width:8px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M198.41 64a4.6 4.6 0 014.59 4.59v130.82a4.6 4.6 0 01-4.59 4.59H67.59a4.6 4.6 0 01-4.59-4.59V68.59A4.6 4.6 0 0167.59 64h130.82m0-8H67.59A12.59 12.59 0 0055 68.59v130.82A12.59 12.59 0 0067.59 212h130.82A12.59 12.59 0 00211 199.41V68.59A12.59 12.59 0 00198.41 56z",
  fill: "#c9c9c9",
  id: "icon-ppsr-disabled_svg__Layer_1",
  "data-name": "Layer 1"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon-ppsr-disabled_svg__Layer_4",
  "data-name": "Layer 4"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-ppsr-disabled_svg__cls-2",
  d: "M120.21 128.81l11.94 13.52M150.44 113.67l-18.29 28.66M133 182.35c51.44-45.42 47.76-79.09 47.76-79.09s-23.88-3.2-40.17-14.33a13.34 13.34 0 00-15.14 0c-16 10.94-40.17 14.33-40.17 14.33s-3.76 33.67 47.72 79.09"
}));

function SvgIconPpsrDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 262 252"
  }, props), _ref, _ref2, _ref3);
}

export default SvgIconPpsrDisabled;